/* fb-video-modal.js — abre un comercial en una ventana dentro de la página (sin salir de ella).
   Cualquier elemento con data-fb-video="<mp4 horizontal>" lo abre; con data-fb-video-v="<mp4 vertical>"
   en pantallas angostas o verticales se usa ese. data-fb-video-title da el nombre para lectores de pantalla.
   Funciona aunque el botón esté dentro de un enlace (el banner del inicio es un <a> completo): el clic
   se atrapa antes y no navega. Se cierra con la X, con Esc o tocando fuera del video. */
(function () {
  'use strict';
  if (window.FBVideo) return;

  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var dlg, vid, lastFocus;

  function vertical() {
    return window.matchMedia('(max-width: 749px), (orientation: portrait) and (max-width: 1024px)').matches;
  }

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'fbvm';
    dlg.setAttribute('aria-label', 'Comercial');
    dlg.innerHTML = '<div class="fbvm__box">'
      + '<button type="button" class="fbvm__close" aria-label="Cerrar video">' + X + '</button>'
      + '<video class="fbvm__video" controls playsinline preload="auto"></video>'
      + '</div>';
    document.body.appendChild(dlg);
    vid = dlg.querySelector('video');
    dlg.querySelector('.fbvm__close').addEventListener('click', close);
    // tocar el fondo (fuera de la caja del video) cierra
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', cleanup);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  }

  function open(src, srcV, title) {
    if (!dlg) build();
    var v = srcV && vertical();
    dlg.classList.toggle('is-v', !!v);
    dlg.setAttribute('aria-label', title || 'Comercial');
    vid.src = v ? srcV : src;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('fbvm-open');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var p = vid.play();
    if (p && p.catch) p.catch(function () {});   // si el navegador no deja reproducir con sonido, quedan los controles
  }

  function close() {
    if (!dlg) return;
    if (dlg.close && dlg.open) dlg.close(); else { dlg.removeAttribute('open'); cleanup(); }
  }

  function cleanup() {
    vid.pause();
    vid.removeAttribute('src');
    vid.load();
    document.documentElement.classList.remove('fbvm-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // el botón puede vivir dentro de un shadow DOM (la página de Cajas): ahí e.target es el anfitrión,
  // así que se busca en la ruta completa del evento
  function find(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i].getAttribute && path[i].hasAttribute('data-fb-video')) return path[i];
    }
    return e.target.closest ? e.target.closest('[data-fb-video]') : null;
  }

  function trigger(e) {
    var t = find(e);
    if (!t) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    open(t.getAttribute('data-fb-video'), t.getAttribute('data-fb-video-v'), t.getAttribute('data-fb-video-title'));
  }

  // en captura: corre antes que el enlace del banner y que cualquier otro manejador
  document.addEventListener('click', trigger, true);
  document.addEventListener('keydown', trigger, true);

  window.FBVideo = { open: open, close: close };
})();
